import { render, staticRenderFns } from "./AdminNoticeRegist.vue?vue&type=template&id=922ae634&scoped=true&lang=pug&"
import script from "./AdminNoticeRegist.vue?vue&type=script&lang=ts&"
export * from "./AdminNoticeRegist.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922ae634",
  null
  
)

export default component.exports